import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { SharedSignupModule } from '@app/shared-signup/shared-signup.module';
import { CartState } from '@app/store/state/cart.state';
import { SignupState } from '@app/store/state/signup.state';
import { LoaderModule } from '@infomaniak/angular-common';
import { TranslocoModule } from '@ngneat/transloco';
import { NgxsModule } from '@ngxs/store';

import { SignupLanguageSwitcherComponent, } from './signup-language-switcher.component';


@NgModule({
  declarations: [
    SignupLanguageSwitcherComponent
  ],
  imports: [
    CommonModule,
    NgxsModule.forFeature([CartState, SignupState]),
    TranslocoModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    LoaderModule,
    SharedSignupModule,
    ReactiveFormsModule,
  ],
  exports: [SignupLanguageSwitcherComponent],
})
export class SignupLanguageSwitcherModule { }
